import { useState } from "react";
import { Radio } from "lucide-react";
import LiveRoom from "./LiveRoom";

// A button that opens a live audio/video room modal.
export default function LiveButton({ scope, targetId, title, label = "Go live", className = "", testid }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button onClick={() => setOpen(true)} data-testid={testid || "live-button"}
        className={className || "inline-flex items-center gap-2 rounded-full bg-[#2A2825] hover:bg-[#413d38] text-[#F4EFE6] px-4 py-2 text-sm transition-colors"}>
        <span className="relative flex h-2 w-2"><span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#E8B486] opacity-75" /><span className="relative inline-flex rounded-full h-2 w-2 bg-[#E8B486]" /></span>
        <Radio className="w-4 h-4" strokeWidth={1.5} />{label}
      </button>
      {open && <LiveRoom scope={scope} targetId={targetId} title={title} onClose={() => setOpen(false)} />}
    </>
  );
}
